import dayjs, { Dayjs } from "dayjs";

// The backend stores a coupon's expiry_date as the first instant the code is
// rejected (it expires when now > expiry_date). Admins think in terms of the
// last day the code still works, so the page converts between the two.

// Stored expiry instant -> last calendar day (local time) the code works.
export const toLastValidDay = (expiryDate: string): Dayjs =>
  dayjs(expiryDate).subtract(1, "millisecond").startOf("day");

// Last valid day picked by the admin -> expiry instant to store
// (midnight at the start of the following day, local time).
export const toExpiryInstant = (lastValidDay: Dayjs): string =>
  lastValidDay.add(1, "day").startOf("day").toISOString();
